export default {
  "investors.title": "Investissez dans l'avenir du tennis africain",
  "investors.subtitle": "Rejoignez le projet de développement sportif le plus ambitieux d'Afrique centrale",
  "investors.vision": "Une Vision Stratégique",
  "investors.visionDesc": "Le Tennis Club de Douala porte une vision avant-gardiste jamais vue au Cameroun, portée par le Président Baby Olivier Pandja.",
  "investors.project1": "Rénovation et construction de courts aux normes ITF",
  "investors.project1Desc": "Remise à neuf des 6 courts existants et extension du complexe avec des surfaces conformes aux standards internationaux. Objectif : homologation ITF complète.",
  "investors.project2": "Programme de formation de coaches certifiés",
  "investors.project2Desc": "Création d'un centre de formation permanent avec des partenariats internationaux. Certification reconnue par les fédérations africaines et mondiales.",
  "investors.project3": "Extension Padel — 2 terrains",
  "investors.project3Desc": "Construction de 2 terrains de Padel, le sport à la croissance la plus rapide au monde. Premier complexe de Padel au Cameroun.",
  "investors.project4": "Académie Tennis Jeunes Talents",
  "investors.project4Desc": "Développement d'une académie pour identifier et former les futurs champions camerounais. Bourses, hébergement, scolarité et entraînement intensif.",
  "investors.project5": "Rayonnement régional Afrique centrale",
  "investors.project5Desc": "Partenariats avec les fédérations africaines, accueil de tournois continentaux et positionnement comme hub tennis de référence.",
  "investors.market": "Marché & Opportunité",
  "investors.market1Title": "27M",
  "investors.market1Desc": "Habitants au Cameroun — classe moyenne en forte croissance",
  "investors.market2Title": "+45%",
  "investors.market2Desc": "Croissance du tennis en Afrique subsaharienne ces 5 dernières années",
  "investors.market3Title": "x3",
  "investors.market3Desc": "Le Padel — adoption multipliée par 3 au niveau mondial en 5 ans",
  "investors.market4Title": "1er",
  "investors.market4Desc": "Complexe sportif tennis-padel de cette envergure en Afrique centrale",
  "investors.cta": "Discuter d'un Partenariat",
  "investors.form.name": "Nom complet",
  "investors.form.organization": "Organisation",
  "investors.form.email": "Email",
  "investors.form.phone": "Téléphone",
  "investors.form.interest": "Projet qui vous intéresse",
  "investors.form.message": "Message",
  "investors.form.cta": "Envoyer",
  "investors.contact": "Contactez-nous directement : contact@tennisclubdouala.com"
}